define('LNRS/Track/TrackFilters',["jquery"], function ($) {

    return function trackFilters(dlmanager) {
        $(".masonry-resource-listing").on("click", "a.ais-menu--link, a.ais-hierarchical-menu--link", function (e) {
            var $el = $(e.target),
                type = $el.closest("[data-id=resource-types]").length ? "filter by resource type" :
                    $el.closest("[data-id=industries]").length ? "filter by industry" : "filter by solution",
                val = $el.text().replace(/\s\s+/g, " ");

            dlmanager.trackAnalytics({
                site_events: { apply_filter: "true" },
                event_name: "filter",
                filter_type: type,
                filter_identifier: val
            });
        });
    };
});
